export const appRoutes = {
  callback: 'callback',
  login: 'login',
  home: 'home',
  activities: 'activities',
  exercise: 'exercise',
  evaluation: 'evaluation',
  correct: 'correct',
  activity: 'activity',
  error: 'error',
  error404: 'error/404',
  errorGroup: 'error/group',
  errorLicense: 'error/license',
  onmatActivitiesTeacher: 'onmat-activities-teacher',
  errorNotFound: '404',
  resources: 'resources',
  groups: 'groups',
  teachers: 'groups/teachers',
  import: 'groups/import/class',
  classManualCreation: 'groups/create',
  classConfiguration: 'groups/import/class/configuration',
  classAlreadyImported: 'groups/import/class/already-imported',
  groupEdit: 'edit',
  itineraries: 'itineraries',
  steps: 'steps',
  step: 'step',
  contents: 'contents',
  tracking: 'tracking',
  student: 'student',
  results: 'results',
  helpCenterEsp: 'https://help.tekmaneducation.com/es/home/c%C3%B3mo-trabajo-con-onmat-gu%C3%ADa-de-primeros-pasos',
  helpCenterCat: 'https://help.tekmaneducation.com/ca-es/home/com-treballo-amb-onmat-guia-de-primers-passos',
  helpCenterOnmat: 'https://help.tekmaneducation.com/es/collections/764209-onmat ',
  myRoom: 'https://myroom.tekmaneducation.com/user/add',
  learnWordsAuthenticate: 'https://tekman.mylearnworlds.com/admin/api/sso',
  learnWordsRedirect: 'https://tekman.mylearnworlds.com/course/',
  teamsLauncher: 'https://teams.microsoft.com/share/launcher.js',
  spaceXReportCAT: 'https://lookerstudio.google.com/embed/reporting/255baa97-d780-44ad-8451-2b159cbb806c/page/56VMB?',
  spaceXReportESP: 'https://lookerstudio.google.com/embed/reporting/8202e49f-bf40-4493-95fd-66decc4f4d96/page/56VMB?',
  spaceXReportMEX: 'https://lookerstudio.google.com/embed/reporting/7751d362-b846-4625-b98e-fbd1db844ea0/page/56VMB',
  spaceXReportECU: 'https://lookerstudio.google.com/embed/reporting/8c2e2011-37ca-45b8-9605-7ae8da84b6dd/page/56VMB',
  videoEsp: 'https://www.youtube.com/embed/HXKS38hil-w?si=GScjrQHakuCL0RoK',
  videoCat: 'https://www.youtube.com/embed/C3UBiUtYAHI?si=OTOBbUZIcJIi0dEd',
};
